export const Colors = {
    defaultContainerColor: "#ffffff", // Colors.white에 해당
    defaultBackgroundColor: "#f3f4f8", // 배경색
    lightgray: "#F5F5F5",
    circleChartBackground: "#F2F3FF",
    tableHoverColor: "#f1f1f1", // 표 셀 호버 시 색
    tableBorderColor: "#ddd", // 표 테두리 색
    tableBorderColor2: "#e6ecf4",
    greyColor: "#89868D",
    boldTextColor: "#3a3541",

    primaryPurpleColor: "#6E39CB",
    mediumPurple: "#9D66FD",
    mediumPurple2: "#B388FE",
    mediumPurple3: "#C9AAFE",
    lightPurple: "#DECCFE",
    lightPurple2: "#9E97FF",
    purpleBlue: "#5932EA",
    slotColor: "#885FED",
    blue: "#5A66F1",
    skyBlue: "#60A5FA",

    whiteBlue: "#EEEFFE",

    loginPurple: "#685FE7",
    loginButtonColor: "#C1BCFF",

    circleChartColor1: "#D9B3FF",
    circleChartColor2: "#B3E6B3",
    circleChartColor3: "#FFB3BA",
    circleChartColor4: "#FFE6B3",
    circleChartColor5: "#B3CDE0",

    red: "#EB6664",
    coralPink: "#E98787",
    green: "#0DA598",
    black: "#000000",
};
